import Swiper from "swiper/bundle";
import gsap from "gsap";
import { fetchGraphQL } from "./libs";
const setTopSlide = async () => {
  const topMvSlideWrapper = document.querySelector('.p-top-mv-slide .swiper-wrapper'),
    splash = document.querySelector('.splash');

  if (!topMvSlideWrapper || !splash) return false;

  const uri = new URL(window.location.href);
  const GET_POSTS = `
    {
      settingsPost(id: ${uri.host === 'www.aiia-pub.com' ? '771' : '162'}, idType: DATABASE_ID) {
        topSlideSettings {
          slideList {
            slideImgPc {
              node {
                sourceUrl
              }
            }
            slideImgSp {
              node {
                sourceUrl
              }
            }
            slideLink
          }
        }
      }
    }
  `;

  const res = await fetchGraphQL(GET_POSTS),
    targetData = res.settingsPost.topSlideSettings,
    topSlideList = targetData.slideList;

  let html = ``;

  topSlideList.forEach((item, index) => {
    html += `
              <div class="swiper-slide">
                <div class="p-top-mv-slide__item">
                  <a href="${item.slideLink}" class="p-top-mv-slide__link">
                    <picture>
                      <source media="(max-width:767px)" srcset="${item.slideImgSp.node.sourceUrl}">
                      <img src="${item.slideImgPc.node.sourceUrl}" alt="スライド画像${index + 1}">
                    </picture>
                  </a>
                </div>
              </div>`;

  });
  topMvSlideWrapper.innerHTML = html

  new Swiper(".js-mv-slide", {
    loop: true,
    centeredSlides: true,
    slidesPerView: '1.26',
    autoplay: {
      delay: 6000,
      stopOnLastSlide: false,
      disableOnInteraction: false,
      pauseOnMouseEnter: false,
      reverseDirection: false,
      waitForTransition: false,
    },
    speed: 500,
    navigation: {
      nextEl: ".p-top-mv .swiper-button-next",
      prevEl: ".p-top-mv .swiper-button-prev",
    },
    pagination: {
      el: ".p-top-mv .swiper-pagination",
      clickable: true,
    },
    breakpoints: { // ブレークポイント
      768: { // 画面幅600px以上で適用
        slidesPerView: 'auto',
      }
    },
    on: {
      afterInit: () => {
        gsap.to(splash, {
          autoAlpha: 0,
          duration: .8,
          ease: 'sine.inOut'
        })
      }
    }
  })
};

export default setTopSlide;